import { render } from "./RequireIntegrationDialog.vue?vue&type=template&id=4126bf8c"
import script from "./RequireIntegrationDialog.vue?vue&type=script&lang=ts"
export * from "./RequireIntegrationDialog.vue?vue&type=script&lang=ts"

import "./RequireIntegrationDialog.vue?vue&type=style&index=0&id=4126bf8c&lang=css"
script.render = render

export default script